import type { Partner_Partner as Partner } from '__generated__/graphql-types-do-not-use';

import config from 'js/app/config';

import type { CourseByIdsQuery } from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/CourseByIds';

export const getPartnerInfo = (
  courseData: CourseByIdsQuery | undefined,
  courseId: string
): Pick<Partner, 'squareLogo' | 'name'> | undefined => {
  if (!courseData) {
    return undefined;
  }

  const foundCourse = courseData.Course?.queryByIds.find((course) => course.id === courseId);
  return foundCourse?.partners[0];
};

export const getCourseVerificationUrl = (verifyCode: string): string | null => {
  if (!verifyCode) {
    return null;
  }
  return `${config.url.base}account/accomplishments/verify/${verifyCode}`;
};
